import i18n from "../../i18n";
import SetupInstructions from "./SetupInstructions";
import SetupPageHeader from "./SetupPageHeader";
import OptionCard, { SetupOptionList } from "./OptionCard";
import DownloadButton from "./DownloadButton";
import headerStyles from "./SetupPageHeader.module.css";
import sharedStyles from "./LockdownSetupInstructions.module.css";
import styles from "./MobileSetupInstructions.module.css";
import AppleLogo from "../../images/portal/apple-logo.svg?react";
import AndroidLogo from "../images/android.svg?react";

export default function MobileSetupInstructions() {
	return (
		<SetupInstructions
			header={
				<SetupPageHeader
					title={i18n.t("setup.components.mobileSetupInstructionsTSX.title")}
					description={i18n.t("setup.components.mobileSetupInstructionsTSX.description")}
				>
					<iframe
						className={headerStyles.video}
						src="https://demo.video.yuja.com/V/Video?v=12435307&node=54238985&a=96784248"
						allowFullScreen
						loading="lazy"
					/>
				</SetupPageHeader>
			}
		>
			<SetupOptionList>
				<OptionCard
					title={i18n.t("setup.components.mobileSetupInstructionsTSX.options.ios.title")}
					platformIcon={
						<div className={styles.iconWrapper}>
							<AppleLogo />
						</div>
					}
				>
					<div className={sharedStyles.downloadOptions}>
						<div className={sharedStyles.downloadButtons}>
							<DownloadButton downloadUrl={"https://apps.apple.com/ca/app/yuja-verity/id6480011608"} openUrl>
								{i18n.t("setup.components.mobileSetupInstructionsTSX.options.ios.download")}
							</DownloadButton>
						</div>
						<div className={sharedStyles.helpText}>
							{i18n.t("setup.components.mobileSetupInstructionsTSX.options.ios.requirement")}
						</div>
					</div>
				</OptionCard>
				<OptionCard
					title={i18n.t("setup.components.mobileSetupInstructionsTSX.options.android.title")}
					platformIcon={
						<div className={styles.iconWrapper}>
							<AndroidLogo />
						</div>
					}
				>
					<div className={sharedStyles.downloadOptions}>
						<div className={sharedStyles.downloadButtons}>
							<DownloadButton downloadUrl={"https://play.google.com/store/apps/details?id=com.yuja.veritymobilelockdown&hl=en_CA&gl=US"} openUrl>
								{i18n.t("setup.components.mobileSetupInstructionsTSX.options.android.download")}
							</DownloadButton>
						</div>
						<div className={sharedStyles.helpText}>
							{i18n.t("setup.components.mobileSetupInstructionsTSX.options.android.requirement")}
						</div>
					</div>
				</OptionCard>
			</SetupOptionList>
		</SetupInstructions>
	);
}
